import React from 'react';
import BaseModal from '../baseModal';

const AdvisoryModal = ({ show, close }) => {
    return (
        <BaseModal show={show} handleClose={close}>
            <div className='list-box'>
                <p id='bns-warning'>Advisory</p>
                <div className='list-container'>
                    <ul id='bnsul'>
                        <li>
                            ℹ️ It looks like your current profile smart contract version is out of date.
                            To unlock banner customization, please deploy and activate the latest version from a new account.
                        </li>
                    </ul>
                </div>
                <button className="button" onClick={close}> Close </button>
            </div>
        </BaseModal>
    );
};

export default AdvisoryModal;